import BaseResource from './index'
import UserResource from './user'

export default class ImageResource extends BaseResource {
    static endpoint = '/images'
    static cacheMaxAge = 3600
    static related() {
        return {
            owner: UserResource,
        }
    }

    static fromDataURL(dataUrl, extraAttrs = {}) {
        let regex = /^data:(.*);(.*),(.*)$/
        let [matchString, mimeType, encoding, source] = dataUrl.match(regex)
        let attrs = Object.assign(
            {
                source,
                encoding: encoding.toUpperCase(),
                mime_type: mimeType,
            },
            extraAttrs
        )
        return new ImageResource(attrs)
    }

    toString() {
        if(this.attributes.encoding === 'BASE64') {
            return `data:${this.attributes.mime_type};base64,${this.attributes.source}`
        }
        return this.attributes.source
    }
}
